export const func = `#version 300 es
precision highp float;
#define PI 3.14159265359
uniform vec2 u_resolution;
uniform float u_time, u_siize;
out vec4 final;

float circleshape(vec2 position, float radius){
    return step(radius, length(position - vec2(0.5)));
}
void main(){
   vec2 coord = gl_FragCoord.xy / u_resolution;
   vec3 color = vec3(0.44 + sin(u_time*0.00025), 0.58+ sin(u_time*0.0005), 0.97);
   vec3 color2 = vec3(0.5);
   vec3 color3 = vec3(0.44 + sin(u_time*0.00025), 0.58+ sin(u_time*0.0005), 0.97);
   color = mix(color,vec3(1.0),sin(u_time*0.0005));
   
//    vec2 translate = vec2(0.0+0.2,0.0+ cos(u_time*0.0005)/5.0); 
   
//    coord += translate ;
   
//    color *= vec3(circleshape(coord+vec2(0.0+sin(u_time*0.0005)/5.0,0.0+ cos(u_time*0.0005)/5.0), 0.2));
//    color3 *= vec3(circleshape(coord+vec2(0.0-sin(u_time*0.0005)/5.0,0.0 - cos(u_time*0.0005)/5.0), 0.2));

color *= vec3(circleshape(coord+vec2(-0.1+sin(u_time*0.0005)/5.0,0.0+ cos(u_time*0.0005)/5.0), 0.3));
color3 *= vec3(circleshape(coord+vec2(0.1-sin(u_time*0.0005)/5.0,0.0 - cos(u_time*0.0005)/5.0), 0.3));


   final = vec4(color2*color*color3,1.0*sin(u_time*0.05));   
}
`;
